export const typesWithTitle = ['web', 'ad', 'productAds'];

// the jsonschema has limitations on string lengths
export const URL_MAX_LENGTH = 300;
export const TITLE_MAX_LENGTH = 200;

// we use different names for the result types in our analytics env
export const getTypeName = (resultType) => {
  switch (resultType) {
    case 'web':
      return 'organic';
    case 'productAds':
      return 'product-ad';
    case 'ad':
      return 'ad-text';
    case 'newsSnippet':
      return 'news';
    case 'imagesSnippet':
      return 'images';
    case 'videosSnippet':
      return 'videos';
    default:
      return 'organic';
  }
};

export const getTitle = (originalTitle, type) => {
  if (originalTitle && typesWithTitle.includes(type)) {
    return originalTitle.substring(0, TITLE_MAX_LENGTH).trim();
  }
  return null;
};

// for now the labels are just lowercased - might change in future
export const getLabel = (originalLabel) => {
  if (!originalLabel || originalLabel === 'NONE') {
    return null;
  }
  return originalLabel.toLowerCase().trim();
};
